export const CREDIT_SCORE_MIN = 400;
export const CREDIT_SCORE_MAX = 850;

const V1_CREDIT_BANDS = new Set([
  'below-580',
  '580-619',
  '620-679',
  '680-739',
  '740-plus',
]);

export function parseCreditScoreInput(v) {
  return String(v ?? '').replace(/\D/g, '').slice(0, 3);
}

export function isValidCreditScore(v) {
  const digits = parseCreditScoreInput(v);
  if (digits.length < 3) return false;
  const n = parseInt(digits, 10);
  return n >= CREDIT_SCORE_MIN && n <= CREDIT_SCORE_MAX;
}

export function formatCreditScoreLabel(v) {
  const n = parseCreditScoreValue(v);
  return n ? String(n) : '';
}

/** Parse numeric score or legacy / V1 band strings. */
export function parseCreditScoreValue(v) {
  const raw = String(v ?? '').trim();
  if (!raw) return null;

  if (V1_CREDIT_BANDS.has(raw)) {
    const mid = {
      'below-580': 560,
      '580-619': 600,
      '620-679': 650,
      '680-739': 710,
      '740-plus': 760,
    };
    return mid[raw];
  }

  const legacyMid = {
    '760+': 780,
    '700-759': 730,
    '680-699': 690,
    '660-679': 670,
    '640-659': 650,
    '620-639': 630,
    '580-619': 600,
    '<580': 560,
    'below-580': 560,
    '740+': 760,
  };
  if (legacyMid[raw]) return legacyMid[raw];

  const digits = raw.replace(/\D/g, '');
  if (!digits) return null;
  const n = parseInt(digits, 10);
  return Number.isFinite(n) ? n : null;
}

/** Legacy rate table key (760+, 700-759, …). */
export function numericToLegacyRateBand(score) {
  const n = parseCreditScoreValue(score);
  if (!n) return '700-759';
  if (n >= 760) return '760+';
  if (n >= 700) return '700-759';
  if (n >= 680) return '680-699';
  if (n >= 660) return '660-679';
  if (n >= 640) return '640-659';
  if (n >= 620) return '620-639';
  if (n >= 580) return '580-619';
  return '<580';
}

/** V1 triage router band. */
export function numericToV1CreditBand(score) {
  const n = parseCreditScoreValue(score);
  if (!n) return null;
  if (n < 580) return 'below-580';
  if (n < 620) return '580-619';
  if (n < 680) return '620-679';
  if (n < 740) return '680-739';
  return '740-plus';
}

export function resolveV1CreditBand(answers = {}) {
  const raw = answers.creditBand || answers.creditScore;
  if (!raw) return null;
  if (V1_CREDIT_BANDS.has(raw)) return raw;
  return numericToV1CreditBand(raw);
}
